import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../core'

export const RESOURCE = {
  payload: {
    description: 'Information used to contact person or organization',
    name: 'Contact Info',
    partialId: PartialId.Standard.create('contact_info'),
  },
  type: core.quiver.Resource.Type.DmsStructure,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsStructure>

// EmailAddresses
// PhoneNumbers
